<template>
  <div class="rContainer">
    <dl class="bsTitleBox">
      <dt class="bsTitle">
        绩效BP权限
      </dt>
    </dl>
    <div class="bsListBox">
      <div class="bsToolBar">
        <a-button
          type="primary"
          @click="showCreate"
        >
          新增绩效BP权限
        </a-button>
      </div>
      <a-table
        :pagination="false"
        row-key="email"
        :loading="loading"
        :columns="columns"
        :data-source="bpList"
      >
        <template
          slot="imageUrl"
          slot-scope="email, record"
        >
          <avatar
            :src="record.imageUrl"
            :width="40"
            :height="40"
          />
        </template>
        <template
          slot="scopes"
          slot-scope="email, record"
        >
          <div
            v-for="(item,index) in record.scopes"
            :key="index"
          >
            {{ item.name }}
          </div>
          <span v-if="record.scopes.length === 0">—</span>
        </template>
        <template
          slot="operation"
          slot-scope="email, record"
        >
          <a
            v-if="record.canDo"
            @click="() => handleDelete(record.userName, record.email)"
          >删除
          </a><a
            v-if="record.canDo"
            @click="() => handleEdit(record.imageUrl, record.userName, record.email, record.scopes)"
          >编辑
          </a>
        </template>
      </a-table>
      <div
        v-if="!bpList.length && !loading"
        class="bsListEmpty"
      >
        <img
          class="bsEmpty"
          src="@assets/images/empty.png"
        >
        <div>咦 ~ 真的什么都没有耶…</div>
      </div>
    </div>
    <a-modal
      v-model="isCreate"
      :title="isEdit ? '编辑绩效BP权限' : '新增绩效BP权限'"
      centered
      class="bsModalForm"
      :mask-closable="false"
      :width="480"
      @ok="handleCreate"
      @cancel="hideCreate"
    >
      <dl>
        <dt>选择绩效BP</dt>
        <dd>
          <a-select
            v-model="selectBP"
            :disabled="isEdit"
            placeholder="请选择绩效BP"
            style="width: 200px;"
            class="bsBPSelect"
            :class="noselectBP ? 'wrong' : ''"
            @change="chooseBP"
          >
            <a-select-option
              v-for="(record, index) in BpNameData"
              :key="index"
              :value="record.email"
            >
              <avatar
                :src="record.imageUrl"
                :width="40"
                :height="40"
              />
              <span style="padding-left:8px;">{{ record.userName }}</span>
            </a-select-option>
          </a-select>
        </dd>
        <dt>
          权限范围
          <span
            v-if="noBpScopes"
            class="wrong"
            style="padding-left:10px;"
          >请添加权限范围</span>
        </dt>
        <dd>
          <a-tag
            v-for="item in BpScopes"
            :key="item.deptId"
            class="bptag"
            closable
            @close="() => handleClose(item.deptId)"
          >
            {{ item.parenttName ? `${item.parenttName}-${item.name}`: item.name }}
          </a-tag>
          <div class="formInline2">
            <a-select
              :value="selectDept"
              show-search
              size="small"
              placeholder="请输入权限范围"
              style="width: 200px"
              :show-arrow="false"
              :filter-option="false"
              :allow-clear="true"
              :not-found-content="null"
              @search="handleSearchDept"
              @change="handleDeptChange"
              @focus="handleClearDept"
            >
              <a-select-option
                v-for="(item,index) in deptData"
                :key="index"
              >
                {{ item.parentDeptName ? `${item.parentDeptName}-${item.deptName}`: item.deptName }}
              </a-select-option>
            </a-select>
            <a-button
              type="primary"
              size="small"
              :disabled="noDept"
              @click="handleAddDept"
            >
              <a-icon type="plus" />
            </a-button>
          </div>
        </dd>
      </dl>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button, Select, Input, Icon, Tag, Table, Modal, Notification, message } from 'ant-design-vue'
import debounce from 'lodash/debounce'
import Avatar from '@components/avatar/index.vue'

Vue.use(Button)
Vue.use(Select)
Vue.use(Input)
Vue.use(Icon)
Vue.use(Tag)
Vue.use(Table)
Vue.use(Modal)

const columns = [
  {
    title: '',
    dataIndex: 'imageUrl',
    width: 40,
    scopedSlots: { customRender: 'imageUrl' },
  },
  { title: '姓名', dataIndex: 'userName' },
  { title: '邮箱', dataIndex: 'email' },
  //   { title: '角色', dataIndex: 'role' },
  { title: '权限范围', dataIndex: 'scopes', scopedSlots: { customRender: 'scopes' } },
  {
    title: '操作',
    dataIndex: 'operation',
    className: 'column-operate',
    scopedSlots: { customRender: 'operation' },
  },
]

export default {
  name: 'BpPermissions',
  components: {
    Avatar,
  },
  data() {
    this.fetchBpDept = debounce(this.fetchBpDept, 1000)
    return {
      currentEmail: '',
      loading: false,
      bpList: [],
      columns,
      isCreate: false,
      isEdit: false,
      BpNameData: [],
      selectBP: undefined,
      BpScopes: [],
      deptData: [],
      selectDept: undefined,
      noDept: true,
      noselectBP: false,
      noBpScopes: false,
    }
  },
  async created() {
    const { email } = await this.$api.user.getUserInfo()
    this.currentEmail = email
    this.fetchBPList()
  },
  methods: {
    // 列表数据格式化，如果是本人，排在第一个并且不能编辑和删除自己
    formateListData(arr) {
      let temIndex = 0
      arr.forEach((element, index) => {
        if (element.email === this.currentEmail) {
          temIndex = index
          this.$set(element, 'canDo', false)
        } else {
          this.$set(element, 'canDo', true)
        }
      })
      if (temIndex !== 0) {
        // 如果当前登录用户没有排在权限角色列表第一个，跟第一个互换位置
        arr[temIndex] = arr.splice(0, 1, arr[temIndex])[0]
      }
      this.$set(this, 'bpList', arr)
    },
    // 获取绩效BP权限列表
    async fetchBPList() {
      this.loading = true
      try {
        const result = await this.$api.backstage.getBpList()
        // eslint-disable-next-line
        console.log('getBPList', result)
        if (result.length === 0) {
          this.roleList = []
        } else {
          this.formateListData(result)
        }
        this.loading = false
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
    // 删除BP权限
    handleDelete(name, email) {
      // eslint-disable-next-line
        console.log(name, email)
      Modal.confirm({
        title: `确定要删除“${name}”的绩效BP权限吗？`,
        content: '点击确认后删除',
        icon: 'close-circle',
        class: 'deleteModal',
        centered: true,
        okText: '确定',
        cancelText: '取消',
        onOk: async () => {
          try {
            await this.$api.backstage.delBp({ email })
            message.success('删除成功！')
            // 刷新列表数据
            this.fetchBPList()
          } catch (error) {
            const msg = error.errorMessage || error.message || '网络错误'
            message.error(msg)
          }
        },
      })
    },
    // 显示创建BP权限弹窗
    showCreate() {
      this.selectBP = undefined
      this.BpScopes = []
      this.isCreate = true
      this.fetchBpNameData()
    },
    // 显示编辑BP权限弹窗
    handleEdit(img, name, e, k) {
      // eslint-disable-next-line
        console.log(img, name,e, k)
      this.BpScopes = []
      this.isEdit = true
      this.isCreate = true
      this.BpNameData = [{
        imageUrl: img,
        userName: name,
        email: e,
      }]
      this.selectBP = e
      k.forEach(i => {
        this.BpScopes.push({
          deptId: i.deptId,
          name: i.name,
        })
      })
      // eslint-disable-next-line
      console.log('BpScopes',this.BpScopes)
    },
    // 隐藏创建BP权限弹窗
    hideCreate() {
      this.isCreate = false
      this.clearModalData()
    },
    // 弹窗数据清空
    clearModalData() {
      this.isEdit = false
      this.noselectBP = false
      this.noBpScopes = false
      this.selectDept = undefined
      this.deptData = []
      this.noDept = true
    },
    // 获取BP列表
    async fetchBpNameData() {
      this.BpNameData = []
      try {
        const result = await this.$api.backstage.getBpNameData({ rolename: '绩效BP' })
        // eslint-disable-next-line
        console.log('BpNameData0', result)
        result.forEach(item => {
          this.BpNameData.push({
            imageUrl: item.image,
            userName: item.userName,
            email: item.email,
          })
        })
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
    // 选择BP
    chooseBP(e) {
      // eslint-disable-next-line
        console.log(e)
      this.selectBP = e
      if (this.noselectBP) {
        this.noselectBP = false
      }
    },
    // 删除权限标签
    handleClose(id) {
      const tags = this.BpScopes.filter(tag => tag.deptId !== id)
      // eslint-disable-next-line
      console.log('id', id, 'BpScopes',this.BpScopes)
      this.BpScopes = tags
      // eslint-disable-next-line
      console.log('del',this.BpScopes)
    },
    // 获取权限范围选项
    async fetchBpDept(dep) {
      try {
        const result = await this.$api.backstage.getBpDepart({ departmentName: dep })
        // eslint-disable-next-line
        console.log('depList', result)
        this.$set(this, 'deptData', result || [])
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        // if (error.code === 'invalidDepartmentName') {}
        message.error(msg)
      }
    },
    // 查询权限范围选项
    handleSearchDept(dep) {
      if (dep) {
        this.fetchBpDept(dep)
      }
    },
    // 选择权限范围
    handleDeptChange (v) {
      // eslint-disable-next-line
      console.log('v', v)
      this.selectDept = v
      if (v === undefined) {
        this.noDept = true
      } else {
        this.noDept = false
      }
    },
    // 清除权限范围报错
    handleClearDept() {
      if (this.noBpScopes) {
        this.noBpScopes = false
      }
    },
    // 检验文本框内容存入数组
    handleAddDept() {
    //   console.log(this.deptData[this.selectDept])
      let duplicate = false
      const item = this.deptData[this.selectDept]
      this.BpScopes.forEach(i => {
        if (i.deptId === item.deptId) {
          duplicate = true
        }
      })
      if (duplicate) {
        message.error('已有该权限范围，请不要重复添加')
      } else {
        const temArr = {
          deptId: item.deptId,
          name: item.deptName,
        }
        if (item.parentDeptName) {
          temArr.parenttName = item.parentDeptName
        }
        this.BpScopes.push(temArr)
        this.selectDept = undefined
        this.deptData = []
        this.noDept = true
      }
    },
    // 点击提交
    async handleCreate() {
      if (!this.selectBP || this.noselectBP) {
        this.noselectBP = true
        this.selectBP = '请选择绩效BP'
      }
      if (this.BpScopes.length === 0) {
        this.noBpScopes = true
      }
      if (this.noselectBP || this.noBpScopes) {
        Notification.open({
          type: 'error',
          message: '填写内容有误或未完成填写',
          description: '请注意红色提示文字。',
          style: 'background-color:#FFECE4',
        })
      } else {
        const temDeptArr = []
        this.BpScopes.forEach(i => {
          if (i.deptId) {
            temDeptArr.push(i.deptId)
          }
        })
        // eslint-disable-next-line
        console.log('temDeptArr', temDeptArr)
        const query = {
          email: this.selectBP,
          scopes: temDeptArr,
        }
        try {
          if (!this.isEdit) {
            await this.$api.backstage.setBp(query)
            message.success('创建成功！')
          } else {
            await this.$api.backstage.editBp(query)
            message.success('修改成功！')
          }
          // 关闭弹框
          this.isCreate = false
          this.isEdit = false
          this.selectDept = undefined
          // 刷新列表数据
          this.fetchBPList()
        } catch (error) {
          const msg = error.errorMessage || error.message || '网络错误'
          message.error(msg)
        }
      }
    },
  },
}
</script>
<style lang="less">
.bsBPSelect{padding-top: 4px;
    .ant-select-selection--single{height: 50px; padding-top: 4px;}
    .ant-select-selection__rendered{line-height: 40px;}}
.bptag{margin-bottom: 6px;}
.formInline2{ button{margin-left: 8px;}}
</style>
